import React from 'react'

import { SearchHistory } from '../types'
import { searchHistory } from '../utils'

export const useSearchHistories = () => {
  const [histories, setHistories] = React.useState<SearchHistory[]>([])

  React.useEffect(() => {
    setHistories(searchHistory.get())
  }, [])

  return histories
}

export const useFacilityNameSearchHistories = () => {
  const [facilityNameHistories, setFacilityNameHistories] = React.useState<
    string[]
  >([])

  React.useEffect(() => {
    setFacilityNameHistories(searchHistory.getFacilityNameHistories())
  }, [])

  return facilityNameHistories
}
